import React from "react";

import { GameInformationSupplementaryDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyIdXboxSupplementaryDataProps = {
  dataInForm: GameInformationSupplementaryDataType;
};

const IdXboxSupplementaryData: Map<string, ReadOnlyFormItem> = new Map([
  [
    "devStudioExperience",
    {
      title: "titlesPreviouslyShippedByYourStudio",
      mapper: (data: GameInformationSupplementaryDataType, localizedStrings: Map<string, string>) =>
        data.devStudioExperience.map(({ platform, gameTitle, yearShipped }) => [
          `${localizedStrings.get("platform")}:  ${platform}`,
          `${localizedStrings.get("gameTitle")}:  ${gameTitle}`,
          `${localizedStrings.get("yearShipped")}:  ${yearShipped}`,
        ]),
    },
  ],
  [
    "teamMembersPreviousTitles",
    {
      title: "titlesPreviouslyShippedByYourTeamMembers",
      mapper: (data: GameInformationSupplementaryDataType, localizedStrings: Map<string, string>) =>
        data.teamMembersPreviousTitles.map(({ platform, memberName, yearShipped, gameTitle }) => [
          `${localizedStrings.get("teamMemberName")}:  ${memberName}`,
          `${localizedStrings.get("gameTitle")}:  ${gameTitle}`,
          `${localizedStrings.get("platform")}:  ${platform}`,
          `${localizedStrings.get("yearShipped")}:  ${yearShipped}`,
        ]),
    },
  ],
  [
    "competitorTitles",
    {
      mapper: (data: GameInformationSupplementaryDataType, localizedStrings: Map<string, string>) =>
        data.competitorTitles.map(({ platform, gameTitle }) => [
          `${localizedStrings.get("gameTitle")}:  ${gameTitle}`,
          `${localizedStrings.get("platform")}:  ${platform}`,
        ]),
    },
  ],
]);

export const ReadOnlyIdXboxSupplementaryData = ({
  dataInForm,
}: ReadOnlyIdXboxSupplementaryDataProps) => {
  const extraStringsToLocalize = [
    "titlesPreviouslyShippedByYourStudio",
    "platform",
    "gameTitle",
    "yearShipped",
    "teamMemberName",
  ];

  return (
    <ReadOnlyForm
      formConfig={IdXboxSupplementaryData}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
